import { DashboardLayout } from "components/Dashboard/DashboardLayout";
import { useBreadcrumb } from "hooks/useBreadcrumbs";
import { useSelectedIdInUrl } from "hooks/useSelectedIdInUrl";
import { useTenant } from "hooks/useTenant";
import { Suspense } from "react";
import { ManifestLineItemDetail } from "../../../ManifestLineItems/Preview/ManifestLineItemDetail";
import { FacilityDetailsTile } from "../FacilityDetailsTile";
import { GeneratorStatusTile } from "../Preview/GeneratorStatusTile";
import { WasteFacilityProvider } from "../Preview/WasteFacilityContext";
import { WasteShipmentsTile } from "../Preview/WasteShipments/WasteShipmentTile";
import { WasteStreamsTile } from "../Preview/WasteStreamsTile";
import { WasteFacilitySkeleton } from "../WasteFacilitySkeleton";
import { ManifestLineItemsTile } from "./ManifestLineItemsTile";
import { WasteFacilityFilters } from "./WasteFacilityFilters";

export const WasteFacility = () => {
  const { tenantId } = useTenant();
  const { selectedId, popIdFromUrl } = useSelectedIdInUrl(
    "wasteLineUnifiedId",
    { prefixSegment: "manifest-line-items" }
  );
  useBreadcrumb([
    {
      label: "Waste",
      to: tenantId ? `/o/${tenantId}/waste` : undefined,
    },
    {
      label: "Facilities",
      to: tenantId ? `/o/${tenantId}/waste/facilities` : undefined,
    },
  ]);

  return (
    <Suspense fallback={<WasteFacilitySkeleton />}>
      <WasteFacilityProvider>
        <WasteFacilityFilters />
        <DashboardLayout>
          <FacilityDetailsTile />
          <GeneratorStatusTile />
          <WasteShipmentsTile />
          <WasteStreamsTile />
          <ManifestLineItemsTile />
        </DashboardLayout>
        <ManifestLineItemDetail
          lineItemId={selectedId}
          open={!!selectedId}
          onClose={popIdFromUrl}
        />
      </WasteFacilityProvider>
    </Suspense>
  );
};
